import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['isAdmin'])
  },
  methods: {
    statusColor (status) {
      const COLORS = {
        'approved': ['is-status-success', 'is-success', 'has-bg-success'],
        'pending': ['is-status-info', 'is-info', 'has-bg-info'],
        'refused': ['is-status-danger', 'is-danger', 'has-bg-danger']
      }
      return COLORS[status]
    },
    canChangeStatus (status) {
      return this.isAdmin
    },
    canExtend (status) {
      const okStatus = ['approved', 'waiting-list']
      return this.isAdmin && okStatus.includes(status)
    },
    canUpgrade (status) {
      const okStatus = ['approved', 'waiting-list']
      return this.isAdmin && okStatus.includes(status)
    },
    canCancel (status) {
      const okStatus = ['approved', 'waiting-list']
      return this.isAdmin && okStatus.includes(status)
    },
    canApprove (status) {
      return this.isAdmin && status === 'pending'
    },
    canRefuse (status) {
      return this.isAdmin && status === 'pending'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/DenunciationStatusMixin.js